import CategoryExceptions from "../constants/categoryExceptions";

export const filterSliderCourses = (coursesArray) => {
  return coursesArray.filter(
    (category) => !CategoryExceptions.hiddenFromSlider.includes(category.slug)
  );
};
